import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CONSTANTS } from 'src/app/constants';
import { ApiService } from 'src/app/shared/service/api.service';

@Component({
selector: 'app-financial-pay-receive',
templateUrl: './financial-pay-receive.component.html',
styleUrls: ['./financial-pay-receive.component.css']
})

export class FinancialPayReceiveComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }
  @Output() errorEmitter = new EventEmitter();

  listCategories: Array<any> = [{label: ''}];
  listPay: Array<any> = [{value: ''}];
  listReceive: Array<any> = [{value: ''}];
  dataSource: any = {
    chart: {
      xAxisName: "Dias",
      yAxisName: "Valor",
      base: "10",
      theme: "fusion",
      paletteColors: "#F1726F, #62B48E",
      showValues: "1",
      numberPrefix: "R$ ",
      placeValuesInside: "0",
      valueBgColor: "#F9F9F9"
    },
    categories: [
      {
        category: []
      }
    ],
    dataset: [
      {
        seriesname: "Pagar",
        data: []
      },
      {
        seriesname: "Receber",
        data: []
      }
    ]
  }

loading: boolean = true;
errorApi: boolean = false;
infoData: any;
message : string = "";

constructor(private api: ApiService) { }

ngOnInit(): void {
}

filterItem(item: any) {
  this.errorApi = false;
  this.loading = true;
  this.payReceiveInformation(item);
}

formatDate(item: any) {
  let data = item;
  let dataSplit = data.split('-');
  let diaSplit = dataSplit[2].split('T');
  let dia = diaSplit[0];
  let mes = dataSplit[1];
  // let ano = dataSplit[0];
  // return dia + "/" + mes + "/" + ano;
  return dia + "/" + mes;
}

cleanVariable() {
  this.listCategories = [{label: ''}];
  this.listPay = [{value: ''}];
  this.listReceive = [{value: ''}];
  this.dataSource.categories[0].category = [];
  this.dataSource.dataset[0].data = [];
  this.dataSource.dataset[1].data = [];
}

payReceiveInformation(item: any) {
  this.api.postBiWeekly(item.branch).subscribe((data: any) => {
    try {
      data.dataRow = data.dataRow.sort((a: any, b: any) => {
        return a.date_expiration.localeCompare(b.date_expiration);
      });
      this.cleanVariable();
      if (data.dataRow.length != 0) {
        data.dataRow.map((el:any) => {
          this.listCategories.push({label: this.formatDate(el.date_expiration)});

          if (el.type_field == 1) {
            this.listPay.push({value: el.value});
          } else {
            this.listReceive.push({value: el.value});
          }
        });
      }
      else {
        this.errorApi = true;
        this.message = CONSTANTS.MESSAGES.DATA_NULL_BIWEEKLY;
        this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_NULL_BIWEEKLY);
      }
      this.listCategories.shift();
      const map = new Map();
      this.listCategories.forEach(item => {
        map.set(item.label, item);
      });
      this.listCategories = Array.from(map.values());
      this.listPay.shift();
      this.listReceive.shift();
      this.dataSource.categories[0].category = this.listCategories;
      this.dataSource.dataset[0].data = this.listPay;
      this.dataSource.dataset[1].data = this.listReceive;
      this.loading = false;
    } 
    catch (error: unknown) {
      this.loading = false;
      this.errorApi = true;
      this.message = CONSTANTS.MESSAGES.DATA_ERRO_BIWEEKLY;
      this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_ERRO_BIWEEKLY);
    }
  });
}

formatErrorMensagem(item: any) {
  let dataError = new Date();
  let errorMensagem = "Arquivo: financial-pay-receive \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
  this.errorEmitter.emit(errorMensagem);
}
}